import { connect } from 'react-redux';
import SaveFormModal from './SaveFormModal';

function mapStateToProps() {
  return {};
}

const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(SaveFormModal);
